export default "__VITE_ASSET__673261e5__"